import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FullScreenState, ScreenShareStatus } from "../globals/enums";

export interface ScreenShareState {
  screenShareStatus: ScreenShareStatus | "";
  screenShareError?: string;
  fullScreenStatus?: string;
}

const initialState: ScreenShareState = {
  screenShareStatus: ""
};

const screenShareSlice = createSlice({
  name: "screenShare",
  initialState,
  reducers: {
    updateScreenGrab: (state: ScreenShareState, action: PayloadAction<ScreenShareState>) => {
      return { ...state, ...action.payload };
    },
    updateFullScreenState: (
      state: ScreenShareState,
      { payload: { fullScreenStatus } }: PayloadAction<{ fullScreenStatus: FullScreenState }>
    ) => {
      state.fullScreenStatus = fullScreenStatus;
    }
  }
});

export const { updateScreenGrab, updateFullScreenState } = screenShareSlice.actions;

export default screenShareSlice;
